import AccessSection from './components/sections/AccessSection'
import EventSection from './components/sections/EventSection'
import DiscordBotSection from './components/sections/DiscordBotSection'
import LootSection from './components/sections/LootSection'
import NotificationSection from './components/sections/NotificationSection'
import PremiumSection from './components/sections/PremiumSection'
import RecruitmentSection from './components/sections/RecruitmentSection'
import TeamSection from './components/sections/TeamSection'
import RosterSection from './components/sections/RosterSection'
import { Button } from '@/components/ui/button'
import EntitySettings from 'app/frontend/base/components/EntitySettings'
import Section from 'app/frontend/base/components/Section'
import { hasAdminAccessToAllTeams } from 'app/frontend/base/config/permissions'
import { useTeam } from 'app/frontend/base/config/context/team'
import { useNavigate } from 'react-router-dom'
import CustomDomainSection from './components/sections/CustomDomainSection'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'

const TeamSettings = () => {
  const { team, guild } = useTeam()
  const navigate = useNavigate()
  const canManageGuild = hasAdminAccessToAllTeams(guild, 'base')
  const { customDomain } = useCustomDomain()

  return (
    <Section title={`Settings | ${team.name} | ${guild.name}`}>
      <EntitySettings
        entityType='team'
        titleAction={
          canManageGuild && !customDomain?.team ? (
            <Button
              variant='outline'
              size='sm'
              onClick={() => navigate(`${guild.path}/settings`)}
            >
              Guild settings
            </Button>
          ) : null
        }
        sections={{
          team: TeamSection,
          events: EventSection,
          loot: LootSection,
          roster: RosterSection,
          recruitment: RecruitmentSection,
          discord_bot: DiscordBotSection,
          access: AccessSection,
          notifications: NotificationSection,
          custom_domain: CustomDomainSection,
          premium: PremiumSection,
        }}
      />
    </Section>
  )
}

export default TeamSettings
